/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1IndividualpaymentParcelsParcelidReintegrateMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidReintegratePathParams,
  PostApiV1IndividualpaymentParcelsParcelidReintegrateQueryParams,
  PostApiV1IndividualpaymentParcelsParcelidReintegrate401,
  PostApiV1IndividualpaymentParcelsParcelidReintegrate404,
  PostApiV1IndividualpaymentParcelsParcelidReintegrate500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidReintegrate.ts";

function getPostApiV1IndividualpaymentParcelsParcelidReintegrateUrl(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidReintegratePathParams["parcelId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/individualpayment/parcels/${parcelId}/reintegrate` as const,
  };
  return res;
}

/**
 * @description Migrado do legado IndividualPayment/ActivateReintegrateParcel. **(Requer Authorization para autenticação)**
 * @summary Marca a parcela para reintegração com o serial informado (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/reintegrate}
 */
export async function postApiV1IndividualpaymentParcelsParcelidReintegrate(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidReintegratePathParams["parcelId"],
  params?: PostApiV1IndividualpaymentParcelsParcelidReintegrateQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1IndividualpaymentParcelsParcelidReintegrateMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidReintegrate401
      | PostApiV1IndividualpaymentParcelsParcelidReintegrate404
      | PostApiV1IndividualpaymentParcelsParcelidReintegrate500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1IndividualpaymentParcelsParcelidReintegrateUrl(
      parcelId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
